import {Message} from "element-ui";

export default {
    methods: {
        dispose({res}) {
            Message({
                message: res.msg,
                type: res.code === 1 ? 'success' : 'error',
                duration: 3 * 1000
            })
        },
        getDataResDispose({res, errorMag, success, error}) {
            if (res.code === -1) {
                Message({
                    message: errorMag ?? res.msg,
                    type: 'error',
                    duration: 3 * 1000
                });
                if (typeof error === "function") {
                    error()
                }
            } else if (res.code === 1) {
                if (typeof success === "function") {
                    success()
                }
            }
        },
        resDispose({res, successMag, errorMag, success, error}) {
            if (res.code === -1) {
                Message({
                    message: errorMag ?? res.msg,
                    type: 'error',
                    duration: 3 * 1000
                });
                if (typeof error === "function") {
                    error()
                }
            } else if (res.code === 1) {
                Message({
                    message: successMag ?? res.msg,
                    type: 'success',
                    duration: 3 * 1000
                });
                if (typeof success === "function") {
                    success()
                }
            }
        },
        resEditNoFetchDialog({res, form = 'params'}) {
            this.dispose({res});
            if (res.code === 1) {
                this.$refs[form].resetFields();
                this.noDialog();
            }
        },
        resEditNoDialog({res, form = 'params'}) {
            this.dispose({res});
            if (res.code === 1) {
                this.$refs[form].resetFields();
                this.fetchNoDialog();
            }
        },
        resNoDialog({res}) {
            this.dispose({res});
            if (res.code === 1) {
                this.fetchNoDialog();
            }
        },
        resFetch({res}) {
            this.dispose({res});
            this.fetchData();
        }
    },
}
